// extracted by mini-css-extract-plugin
module.exports = {"text":"text-module--text--jUjBk","single":"text-module--single--2Iq4y"};